// Node.js entry point - uses native Sharp
import { nodeImageOps } from "../image/adapters/node";

// Re-export all types and functions from the main index
export * from "../index";

// Override the image operations with Node-specific implementation
import { imageOps } from "../index";
imageOps.svgToPng = nodeImageOps.svgToPng;
imageOps.isAvailable = nodeImageOps.isAvailable;
